import type { Traducao } from '../tipos';

/** Login, esqueci a senha, pedir acesso e as rotas protegidas. */
export const auth: Traducao = {
  pt: {
    login: {
      marca: {
        chamada:
          'Apreciação de riscos em máquinas e equipamentos, da inspeção em campo ao laudo técnico assinado.',
        apoio:
          'Inventário de ativos, cálculo de criticidade, plano de ação e emissão de documentação técnica — em um só lugar.',
      },
      titulo: 'Acessar o sistema',
      subtitulo: 'Entre com suas credenciais para continuar.',
      erroCredenciais: 'Email ou senha incorretos',
    },
    formulario: {
      email: 'E-mail',
      emailPlaceholder: 'seu.nome@schmersal.com.br',
      senha: 'Senha',
      mostrarSenha: 'Mostrar senha',
      ocultarSenha: 'Ocultar senha',
      capsLock: 'Caps Lock está ativado',
      entrar: 'Entrar',
      entrando: 'Entrando…',
      rodape: 'Acesso restrito. Em caso de problemas, procure o administrador do sistema.',
      validacao: {
        emailObrigatorio: 'Informe seu e-mail',
        emailInvalido: 'E-mail inválido',
        senhaObrigatoria: 'Informe sua senha',
      },
    },
    esqueciSenha: {
      titulo: 'Esqueci minha senha',
      subtitulo: 'Informe seu email e enviaremos instruções para redefinir sua senha',
      email: 'Email',
      emailInvalido: 'Email inválido',
      regras: {
        titulo: 'Regras de senha:',
        caracteres: 'Mínimo de 8 caracteres',
        maiuscula: 'Pelo menos uma letra maiúscula',
        minuscula: 'Pelo menos uma letra minúscula',
        numero: 'Pelo menos um número',
        especial: 'Pelo menos um caractere especial',
      },
      enviar: 'Enviar instruções',
      enviando: 'Enviando...',
      voltarLogin: 'Voltar ao login',
      enviado: {
        titulo: 'Instruções enviadas',
        mensagem:
          'Se existir uma conta com o email informado, enviamos instruções para redefinir sua senha. Verifique sua caixa de entrada e spam.',
      },
    },
    solicitarAcesso: {
      titulo: 'Solicitar acesso',
      subtitulo:
        'Preencha o formulário abaixo para solicitar acesso ao RiskGuard. Nossa equipe entrará em contato em até 2 dias úteis.',
      formularioTitulo: 'Solicitar acesso ao RiskGuard',
      formularioDescricao:
        'Preencha seus dados e nossa equipe entrará em contato para provisionar sua conta.',
    },
    painel: {
      subtitulo: 'Gestão de riscos com rastreabilidade e consistência',
      imagemAlt: 'Profissionais trabalhando juntos',
      beneficios: {
        padronizacao: 'Apreciação de riscos padronizada',
        rastreabilidade: 'Rastreabilidade completa',
        relatorios: 'Relatórios e exportação',
        acesso: 'Acesso seguro',
      },
    },
    credito: {
      desenvolvidoPor: 'Desenvolvido por',
      aria: 'Desenvolvido por {{nome}}',
    },
    sso: {
      microsoft: 'Entrar com Microsoft',
      google: 'Entrar com Google',
    },
    rota: {
      carregandoSessao: 'Carregando sessão...',
      acessoNegado: 'Acesso Negado',
      semPermissaoPagina: 'Você não tem permissão para acessar esta página.',
      semPermissaoArea: 'Você não tem permissão para acessar esta área.',
    },
  },
  en: {
    login: {
      marca: {
        chamada:
          'Risk assessment for machines and equipment, from the field inspection to the signed technical report.',
        apoio:
          'Asset inventory, criticality rating, action plan and technical documentation — all in one place.',
      },
      titulo: 'Sign in to the system',
      subtitulo: 'Enter your credentials to continue.',
      erroCredenciais: 'Incorrect email or password',
    },
    formulario: {
      email: 'Email',
      emailPlaceholder: 'your.name@schmersal.com.br',
      senha: 'Password',
      mostrarSenha: 'Show password',
      ocultarSenha: 'Hide password',
      capsLock: 'Caps Lock is on',
      entrar: 'Sign in',
      entrando: 'Signing in…',
      rodape: 'Restricted access. If you run into trouble, contact the system administrator.',
      validacao: {
        emailObrigatorio: 'Enter your email',
        emailInvalido: 'Invalid email',
        senhaObrigatoria: 'Enter your password',
      },
    },
    esqueciSenha: {
      titulo: 'Forgot my password',
      subtitulo: 'Enter your email and we will send instructions to reset your password',
      email: 'Email',
      emailInvalido: 'Invalid email',
      regras: {
        titulo: 'Password rules:',
        caracteres: 'At least 8 characters',
        maiuscula: 'At least one uppercase letter',
        minuscula: 'At least one lowercase letter',
        numero: 'At least one number',
        especial: 'At least one special character',
      },
      enviar: 'Send instructions',
      enviando: 'Sending...',
      voltarLogin: 'Back to login',
      enviado: {
        titulo: 'Instructions sent',
        mensagem:
          'If an account exists for the email provided, we have sent instructions to reset your password. Check your inbox and spam folder.',
      },
    },
    solicitarAcesso: {
      titulo: 'Request access',
      subtitulo:
        'Fill in the form below to request access to RiskGuard. Our team will get in touch within 2 business days.',
      formularioTitulo: 'Request access to RiskGuard',
      formularioDescricao:
        'Fill in your details and our team will get in touch to provision your account.',
    },
    painel: {
      subtitulo: 'Risk management with traceability and consistency',
      imagemAlt: 'Professionals working together',
      beneficios: {
        padronizacao: 'Standardized risk assessment',
        rastreabilidade: 'Full traceability',
        relatorios: 'Reports and export',
        acesso: 'Secure access',
      },
    },
    credito: {
      desenvolvidoPor: 'Developed by',
      aria: 'Developed by {{nome}}',
    },
    sso: {
      microsoft: 'Sign in with Microsoft',
      google: 'Sign in with Google',
    },
    rota: {
      carregandoSessao: 'Loading session...',
      acessoNegado: 'Access Denied',
      semPermissaoPagina: 'You do not have permission to access this page.',
      semPermissaoArea: 'You do not have permission to access this area.',
    },
  },
};
